// AI tag suggestions are free text. A suggestion only becomes a tag when it
// names one of the book's saved tags (case-insensitive), so every composer
// matches the same way and never creates a tag from model output.

// Trimmed, non-empty and unique ignoring case (the first spelling wins), so
// "NBA" and "nba" never render as two chips for one saved tag.
export function normalizeTagSuggestions(suggestions = []) {
  const seen = new Set()
  return (Array.isArray(suggestions) ? suggestions : [])
    .map((suggestion) => String(suggestion || '').trim())
    .filter((suggestion) => {
      const key = suggestion.toLowerCase()
      if (!suggestion || seen.has(key)) return false
      seen.add(key)
      return true
    })
}

export function findSuggestedTag(tags = [], suggestion = '') {
  const wanted = String(suggestion || '').trim().toLowerCase()
  if (!wanted) return null
  return (tags || []).find((tag) => String(tag?.label || '').trim().toLowerCase() === wanted) || null
}

export function matchSuggestedTagIds(tags = [], suggestions = []) {
  return Array.from(new Set(
    normalizeTagSuggestions(suggestions)
      .map((suggestion) => findSuggestedTag(tags, suggestion)?.id)
      .filter(Boolean),
  ))
}
